Render.add('input[name=agreement]', function(){
    $(this).trigger("change");
});

$("body").on("change", "input[name=agreement]", function(){
    $(this).closest("form").find(".btn-submit").prop("disabled", !$(this).prop('checked'));
});


